/*eslint-disable */
// import QuestionResultModel from '../../Model/QuestionResult'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility"

let AppResults = {
  /**
   * appResultList
   */
  async appResultList (context, appResultObj) {
    try{
      let post_data = new FormData();

      for (let key in appResultObj) {
        if (appResultObj[key]) {
          post_data.append(key, appResultObj[key]);
        }
      }
      return await request.curl(context, "apps_results_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at appResultList() and Exception:',err.message)
    }
  },

  /**
   * appResultAllAverage
   */
  async appResultAllAverage (context, appResultObj) {
    try{
      let post_data = new FormData();

      for (let key in appResultObj) {
        if (appResultObj[key]) {
          post_data.append(key, appResultObj[key]);
        }
      }
      return await request.curl(context, "apps_all_results_average", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at appResultAllAverage() and Exception:',err.message)
    }
  },

  /**
   * appResultAllCategoryAverage
   */
  async appResultAllCategoryAverage (context, appResultObj) {
    try{
      let post_data = new FormData();

      for (let key in appResultObj) {
        if (appResultObj[key]) {
          post_data.append(key, appResultObj[key]);
        }
      }
      return await request.curl(context, "apps_all_results_category_average", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at appResultAllAverage() and Exception:',err.message)
    }
  },
  /**
   * appResultConsoleList
   *
   */
  async appResultConsoleList (context, appResultObj, filter  = {}) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";
      let post_data = new FormData();

      for (let key in appResultObj) {
        if (appResultObj[key]) {
          post_data.append(key, appResultObj[key]);
        }
      }

      if (filter) {
        post_data.append('filter', JSON.stringify(filter));
      }

      return await request.curl(context, "apps_results_console_list", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at appResultList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * appResultSync
   */
  async appResultSync (context, appResultObj) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait...."; 

    try{
      let post_data = new FormData();
      for (let key in appResultObj) {
        if (appResultObj[key]) {
          post_data.append(key, appResultObj[key]);
        }
      }
  
      return await request.curl(context, "apps_results_percentile_sync", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at appResultList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * appResultLeaderBoard
   */
   async appResultLeaderBoard (context, appId, limit = null, offset = 0) {
    try{
      let post_data = new FormData();
      post_data.append("app_id", appId)
      post_data.append("offset", offset)

      if (limit) {
        post_data.append("limit", limit)
      }

      return await request.curl(context, "apps_results_leader_board", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at appResultList() and Exception:',err.message)
    }
  },
  /**
   * appResultView
   */
  async appResultView (context, appResultObj) {
    try {      
      let post_data = new FormData();
      for (let key in appResultObj) {
        if (appResultObj[key] || typeof appResultObj[key] == 'number') {
          post_data.append(key, appResultObj[key]);
        }
      }

      return await request.curl(context, "apps_results_view", post_data, process.env.VUE_APP_QUIZ_SERVICE)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at appResultView() and Exception:",err.message)
    }    
  },

  /**
   * appResultAdd
   */
  async appResultAdd (context, appResultObj) {
    try{
      let post_data = new FormData();
    
      for (let key in appResultObj) {
        post_data.append(key, appResultObj[key]);
      }

      return await request.curl(context, "apps_results_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at appResultAdd() and Exception:',err.message)
    }
  },

  /**
   * appResultEdit
   */
  async appResultEdit (context, appResultObj) {
    try{
      let post_data = new FormData();
    
      for (let key in appResultObj) {
        post_data.append(key, appResultObj[key]);
      }

      return await request.curl(context, "apps_results_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at appResultEdit() and Exception:',err.message)
    }
  },

  /**
   * appResultsAllEdit
   */
  async appResultsAllEdit (context, appResultObj) {
    try{
      let post_data = new FormData();
    
      for (let key in appResultObj) {
        post_data.append(key, appResultObj[key]);
      }

      return await request.curl(context, "apps_results_all_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at appResultsAllEdit() and Exception:',err.message)
    }
  },

  /**
   * appResultsAllPublishUnpublish
   */
  async appResultsAllPublishUnpublish (context, appResultObj) {
    try{
      let post_data = new FormData();

      for (let key in appResultObj) {
        post_data.append(key, appResultObj[key]);
      }

      return await request.curl(context, "apps_results_all_publish_unpublish", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at appResultsAllPublishUnpublish() and Exception:',err.message)
    }
  },

  /**
   * appResultDelete
   */
  async appResultDelete (context, appResultId) {
    try{
      let post_data = new FormData();
      
      post_data.append('aprs_id', appResultId);

      return await request.curl(context, "apps_results_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at appResultDelete() and Exception:',err.message)
    }
  },

  /**
   * gptResultInsights
   */
  async gptResultInsights(context, chainItem, result_owner_id) {
    try{
      let post_data = new FormData();
      
      post_data.append('result_owner_id', result_owner_id);
      post_data.append('qbkCat', JSON.stringify(chainItem.qbkCat));
      post_data.append('app_id', chainItem.app_id);
      post_data.append('aprs_id', chainItem.aprs_id);

      return await request.curl(context, "apps_gpt_results_insights", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at gptResultInsights() and Exception:',err.message)
    }
  },

  /**
   * appsResultsSessionCreate
   */
  async appsResultsSessionCreate (context, appsResultsSessionObj) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait....";

    try{
      let post_data = new FormData();

      for (let key in appsResultsSessionObj) {
        if (appsResultsSessionObj[key]) {
          post_data.append(key, appsResultsSessionObj[key]);
        }
        else if (typeof appsResultsSessionObj[key] == 'number' && appsResultsSessionObj[key] == 0) {
          post_data.append(key, appsResultsSessionObj[key]);
        }
      }

      let api = process.env.VUE_APP_QUIZ_SERVICE

      return await request.curl(context, "apps_results_session_create", post_data, api)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at appsResultsSessionCreate() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * appQuizAnswerCategorySync
   */
  async appQuizAnswerCategorySync (context, appResultObj) {
    try{
      let post_data = new FormData();

      for (let key in appResultObj) {
        if (appResultObj[key]) {
          post_data.append(key, appResultObj[key]);
        }
      }
      return await request.curl(context, "apps_quiz_answer_category_sync", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at appQuizAnswerCategorySync() and Exception:',err.message)
    }
  }
}

export {
  AppResults
}
